<template>
  <div class="d-flex align-center itemToListBtn">
    <template v-if="userData.id === 0">
      <a @click="showLogin()" class="text-muted add-to-wish-list" aria-label="show login">
        <template v-if="loading">
          <i class="fa fa-spin fa-circle-o-notch" aria-hidden="true"></i>
        </template>
        <template v-else>
          <i class="fa" :class="[idInWishListIds ? 'fa-thumb-tack' : 'fa-thumb-tack']" aria-hidden="true"></i>
        </template>
        <template v-if="showWording">{{ $translate("CartSave::Template.cartWishList") }}</template>
      </a>
    </template>
    <template v-else>
      <a @mouseover.once="$store.dispatch('loadComponent', 'csmodal');"  @click="addItem()" class="text-muted add-to-wish-list" aria-label="add item to wishlist"  :class="{ 'inList' : idInWishListIds }">
        <template v-if="loading">
          <i class="fa fa-spin fa-circle-o-notch" aria-hidden="true"></i>
        </template>
        <template v-else>
          <i class="fa" :class="[idInWishListIds ? 'fa-thumb-tack' : 'fa-thumb-tack']" aria-hidden="true"></i>
        </template>
        <template v-if="showWording">{{ $translate("CartSave::Template.cartWishList") }}</template>
      </a>
    </template>
  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  name: "CsAddToList",
  props:
  {
    variationId:
    {
      type: Number,
      default:0
    },
    quantity:
    {
      type: Number,
      default:1
    },
    showWording:
    {
      type:Boolean,
      default:false
    },
    currentItemId:
    {
      type: Number,
      default:0
    },
    deleteItemFromBasket:
    {
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      loading:false
    }
  },
  inject: {
    itemId: {
      default: null
    }
  },
  computed:
  {
    idInWishListIds()
    {
      if(this.wishlistids.indexOf(this.variationId) > - 1 || this.wishlistids.indexOf(this.currentItemId) > -1 )
      {
        return true;
      }
      else
      {
        return false;
      }
    },
    userData()
    {
      let user = this.$store.state.user.userData;
      let userObj =
          {
            "email":'',
            "id":0
          }
      if(user != null)
      {
        userObj.email = user.email
        userObj.id    = user.id
      }
      return userObj;
    },
    ...mapState({
      wishlistids: state => state.cartsave.ids
    })

  },
  methods:
  {
    currentVariation: function()
    {
      return this.$store.state.items[`${this.itemId}`];
    },
    addItem()
    {
      let variationQuantity = this.quantity;
      let variationId       = this.variationId;
      let itemId            = this.currentItemId;
      let deleteBasketItem  = this.deleteItemFromBasket;
      if(variationId === 0 && itemId === 0)
      {
        variationQuantity    = this.currentVariation().variationOrderQuantity;
        variationId          = this.currentVariation().variation.documents[0].id;
        itemId               = this.itemId;
      }
      this.$store.commit('setItem', { id: variationId, quantity:variationQuantity, itemId: itemId, deleteBasketItem: deleteBasketItem });
      $('#addToList').modal('show');
      $('.cartsave-dropshadow,.cartsave-slideIn').addClass('show');
      $('body').addClass('noScroll')
    },
    showLogin()
    {
      this.$store.dispatch('loadComponent', 'login-modal')
      $('#login').modal("show")
    },
  }
}
</script>
